export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7402.0d192058.jpg";